export default [
  {
    path: '/admin/payroll-cycles',
    name: 'payroll-cycle',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payroll/payroll-cycle/index.vue')
  }
]
